import script from "./MinimizedCallView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MinimizedCallView.vue?vue&type=script&setup=true&lang=ts"

import "./MinimizedCallView.vue?vue&type=style&index=0&id=68090fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68090fcc"]])

export default __exports__